import { render, staticRenderFns } from "./ViewDisputes.vue?vue&type=template&id=5db8f60f&lang=pug"
import script from "./ViewDisputes.vue?vue&type=script&lang=js"
export * from "./ViewDisputes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports